<!--toggle chatbot Icon-->
<!--<div class="welcome-message-toggle">-->
<!--  <div class="welcome-message" *ngIf="lastMsg.message">-->
<!--    <i-->
<!--      class="fa fa-times welcome-close"-->
<!--      aria-hidden="true"-->
<!--      (click)="closeMessage()"-->
<!--    ></i>-->
<!--    <p class="head">Omantel Intelligent Assistant</p>-->
<!--    <div class="body" [innerHtml]="lastMsg.message"></div>-->
<!--  </div>-->
<!--</div>-->

<app-chatbot-icon [imgName]="'ot_icon_noor_full_90x90 2.svg'" (clearMessages)="clearMessages()" (sendMsgEv)="sendMessage($event.msg, null, null, null, 'false')"></app-chatbot-icon>

<div class="chatbot-container">
  <!--Header of Chatbot-->

  <app-header
      [chatbot_lang]="chatbotLang"
      (clearMessages)="clearMessages()"
      (toggleRatingModelEV)="appStarRatingModal.triggerRatingModule(starRatingModuleTriggerCount);triggerRatingModuleFrom('header-component')">
  </app-header>
  

  <!--Body of Chatbot-->
  <div class="chat-boat-body" id="chat-bot" style="flex: 1 1 auto">

    <div id="content" class="mt-2 mb-0 pb-3">
      <ng-container *ngIf="messages | async as msgs">
        <div
          *ngFor="let message of msgs; let last = last; let i = index" 
          id="message_{{i}}">
          <app-message
            [intentName]="greet"
            (suggestionMsgEv)="
              sendMessage($event.msg, $event.divId, $event.slotToElicit, null, null, $event.sessionAttributes, $event.clickedButton)
            "
            [message]="message"
            [lastMsg]="lastMsg"
            (triggerRatingModuleEV)="appStarRatingModal.triggerRatingModule(starRatingModuleTriggerCount); triggerRatingModuleFrom('message-component')"
          ></app-message>

        </div>
      </ng-container>

    </div>
  </div>



  <!--Footer of Chatbot-->
  <app-footer
    [(inputValue)]="formValue"
    [numberKeypressOnly] = 'numberKeypressOnly'
    (inputValueChange) = "inputValueChange($event)"
    (sendMsgEv)="sendMessage()"
    (fileUploadEv)="importFile($event)"
  ></app-footer>
</div>
<app-star-rating-modal #appStarRatingModal (clearMessages)="clearMessages()" ></app-star-rating-modal>
